import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/storage-hub/")({
  staticData: {
    title: "apps.storageHub",
  },
  loader: () => redirect({ to: "/storage-hub/capture-storage" }),
});
